import { render, staticRenderFns } from "./PBadge.vue?vue&type=template&id=20a0687a&scoped=true"
import script from "./PBadge.vue?vue&type=script&lang=js"
export * from "./PBadge.vue?vue&type=script&lang=js"
import style0 from "./PBadge.vue?vue&type=style&index=0&id=20a0687a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a0687a",
  null
  
)

export default component.exports